/* eslint-disable no-underscore-dangle */
import React from 'react';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';
import { useField } from 'formik';
import { at } from 'lodash';

const CheckboxField = (props: any) => {
  const { label, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;

  function renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
    return null;
  }

  function _onChange(e: React.ChangeEvent<HTMLInputElement>) {
    setValue(e.target.checked);
  }

  return (
    <FormControl {...rest}>
      <FormControlLabel
        value={field.checked}
        checked={field.checked}
        control={<Checkbox {...field} onChange={_onChange} />}
        label={label}
      />
      {renderHelperText()}
    </FormControl>
  );
};

export default CheckboxField;
